import channelView from "./ChannelView";

export default channelView;
